import { getMimeType, mimeCategory } from './mime.js';

export function isImage(f: File | Blob | string): boolean {
  return mimeCategory(getMimeType(f)) === 'image';
}

export function isVideo(f: File | Blob | string): boolean {
  return mimeCategory(getMimeType(f)) === 'video';
}

export function isAudio(f: File | Blob | string): boolean {
  return mimeCategory(getMimeType(f)) === 'audio';
}

export function isDocument(f: File | Blob | string): boolean {
  return mimeCategory(getMimeType(f)) === 'document';
}

export function isWithinSize(f: { size: number }, maxBytes: number): boolean {
  return f.size <= maxBytes;
}
